<template>
  <div class="project-bd tb" style="padding: 0">
    <custom-tab v-model="tabIndex" :list="tabList"></custom-tab>
    <location v-if="tabIndex === '1'"></location>
    <site v-if="tabIndex === '2'"></site>
    <plan v-if="tabIndex === '3'"></plan>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import location from './children/location.vue';
import site from './children/site.vue';
import plan from './children/plan.vue';

export default {
  name: 'project',
  mixins: [],
  components: { location, site, plan },
  data() {
    return {
      provide: true,
      tableSelect: [],

      tabIndex: '',
      tabList: [],
    };
  },

  mounted: function () {
    this.getFuncView(null, () => {
      const tab = [];
      if (this.funcView.project_list) {
        tab.push({ name: this.$t('dms_project.xiang_mu'), value: '1' });
      }
      if (this.funcView.site_list) {
        tab.push({ name: this.$t('dms_project.qu_yu'), value: '2' });
      }
      if (this.funcView.location_plan_list) {
        tab.push({ name: this.$t('dms_project.ji_hua'), value: '3' });
      }
      this.tabList = tab;
      this.tabIndex = tab[0].value;
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.project-bd {
  .stock-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
  }
}
</style>
